import { css } from 'lit-element';

export class LinkStyles {

  static get styles() {
    return css`
        :host {
            user-select: none;
            cursor:pointer;
        }

        :host([hidden]) {
            display: none;
        }

        :host(:hover) {
            text-decoration:underline;
        }

        a {
            text-decoration:none;
            flex:1;
            color:var(--routed-link-color)
        }
    `
  }

}



